import React from 'react';

interface Props {
  className?: string;
}

const CreamCan = ({ className }: Props) => (
  <img src='../assets/images/common/cream_can.png' className={className} />
);

export default CreamCan;
